import { Wifi, WifiOffIcon } from "lucide-react";
import {
  DEVICE_ONLINE_STATES,
  getDeviceOnlineState,
} from "../../utils/devices";
import strings from "../../i18n/i18nStrings";
import dayjs from "dayjs";
import { CONFIG } from "../../constants/config";

const DeviceOnlineStateIcon = ({
  updated_at,
  showLabel = true,
}: {
  updated_at: Date;
  showLabel?: boolean;
}) => {
  switch (getDeviceOnlineState(updated_at)) {
    case DEVICE_ONLINE_STATES.ONLINE:
      return (
        <span
          className=" text-sm font-semibold text-blue-600"
          title={`Last Online: ${
            updated_at
              ? dayjs(updated_at).format(CONFIG.STANDARD_DATETIME_FORMAT)
              : "N/a"
          }`}
        >
          <Wifi className="w-6 h-6 text-blue-600 animate-pulse" />
          {showLabel && strings.deviceDetailModal.online}
        </span>
      );
    case DEVICE_ONLINE_STATES.WARNING:
      return (
        <span
          className="px-3 pt-2 text-sm font-semibold text-yellow-600"
          title={`Last Online: ${
            updated_at
              ? dayjs(updated_at).format(CONFIG.STANDARD_DATETIME_FORMAT)
              : "N/a"
          }`}
        >
          <Wifi className="w-6 h-6 text-yellow-600" />
          {showLabel && strings.deviceDetailModal.online}
        </span>
      );
    case DEVICE_ONLINE_STATES.OFFLINE:
      return (
        <span
          className="px-3 pt-2 text-sm font-semibold text-red-700"
          title={`Last Online: ${
            updated_at
              ? dayjs(updated_at).format(CONFIG.STANDARD_DATETIME_FORMAT)
              : "N/a"
          }`}
        >
          <WifiOffIcon className="w-6 h-6 text-red-700" />
          {showLabel && strings.deviceDetailModal.offline}
        </span>
      );
    default:
      return null;
  }
};

export default DeviceOnlineStateIcon;
